module.exports = {
      id: "logo-usage",
      viewBox: "0 0 1280 843.3",
      url: __webpack_public_path__ + "img/icons.a0c47b73.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }